import healthStatusMixin from '@/components/core/virtualDevice/healthStatusMixin';
import get from 'lodash/get';
export default {
  name: 'CoreVirtualDeviceHealthStatusColumn',
  mixins: [healthStatusMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    computedErrors() {
      return this.getWithDefaultForNull(this.item, 'health.errors', []).map(this.addIsIgnoredFlag);
    },
    computedWarnings() {
      return this.getWithDefaultForNull(this.item, 'health.warnings', []).map(this.addIsIgnoredFlag);
    },
    invalidHealthState() {
      return [0, 1, 2, 3].includes(this.item.state) === true;
    }
  },
  methods: {
    getWithDefaultForNull(obj, path, defaultValue) {
      const result = get(obj, path, defaultValue);
      return result === null ? defaultValue : result;
    },
    addIsIgnoredFlag(issue) {
      const healthConfig = this.getWithDefaultForNull(this.item, 'healthConfig', []);
      const correspondingConfig = healthConfig.find(config => config.identifier === issue.id);
      if (correspondingConfig) {
        issue._isIgnored = correspondingConfig.isIgnored || false;
      }
      return issue;
    }
  }
};